import React from "react";
import '../styles/Home.css'
import Services from './Service'
import ContactUs from './Contact'
import Hero from "./Hero";
import Solutiongallery from "./Solutiongallery";
import Career from "./Career";
import About from "./About";
import Mainpage from "./mainpage";

const Home = () => {


  return (
    <>


      <Hero />
      <About/>
      <Services />
      <Solutiongallery/>
      <ContactUs />
      <Career/>
    </>
  )
}

export default Home
